import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import AsyncSelect from 'components/AsyncSelect';
import IconButton from 'components/IconButton';
import {DetailTenantInfo, DetailTeamInfo} from 'components/TenantInfo';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import 'components/Filters/styles.css';
import './styles.css';

export const buildCreatedByOptions = ({admins, teams}) => {
  const adminsOptions = admins.map(admin => ({
    label: admin.fullName,
    value: admin.id,
    object: admin
  }));

  const teamsOptions = teams.map(team => ({
    label: team.name,
    value: team.id,
    object: {...team, isTeam: true}
  }));

  return [...adminsOptions, ...teamsOptions];
};

interface CreatedByAdminOrTeamFilterProps {
  fetchFunction: any;
  clearOption: any;
  onChange: any;
  createdByRef: any;
}

const OptionRenderer = option => {
  if (option.object.isTeam) {
    return <DetailTeamInfo team={option.object} />;
  }
  return <DetailTenantInfo tenant={option.object} />;
};

// This component is almost the same as BookerFilter and CustomerFilter.
// It is like that on purpose to be more easily mainatined in future
class CreatedByAdminOrTeamFilter extends React.Component<
  CreatedByAdminOrTeamFilterProps
> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  render() {
    return (
      <div
        className={classNames('FilterSection CreatedByAdminOrTeamFilter', {
          'FilterSection--opened': this.state.sectionOpened
        })}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Created By</div>
        </div>
        <div className="FilterSection__content">
          <div>
            <AsyncSelect
              ref={this.props.createdByRef}
              fetchFunction={this.props.fetchFunction}
              buildOptions={buildCreatedByOptions}
              onClear={this.props.clearOption}
              optionRenderer={OptionRenderer}
              valueRenderer={OptionRenderer}
              arrowRenderer={null}
              creatable={false}
              filterOptions={false}
              placeholder={'Search by name or email'}
              onChange={this.props.onChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CreatedByAdminOrTeamFilter;
